import { render, staticRenderFns } from "./UserGroupBrowse.vue?vue&type=template&id=474ef864"
import script from "./UserGroupBrowse.vue?vue&type=script&lang=js"
export * from "./UserGroupBrowse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports